var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeduplicate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M13.875 6.675a.45.45 0 0 0-.45-.45h-4.8a1.5 1.5 0 0 0-1.5 1.5v4.482a1.5 1.5 0 0 0 1.5 1.5h3.3q.021 0 .042-.002l-.607.607a.368.368 0 0 0 .521.52l1.25-1.25a.46.46 0 0 0 0-.65l-1.253-1.252a.368.368 0 0 0-.52.52l.608.609-.041-.002h-3.3a.6.6 0 0 1-.6-.6V7.725a.6.6 0 0 1 .6-.6h4.8a.45.45 0 0 0 .45-.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M10.875 9.668h4.5a.6.6 0 0 1 .6.6v6a.6.6 0 0 1-.6.6h-4.5a.6.6 0 0 1-.6-.6.45.45 0 0 0-.9 0 1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5.452.452 0 0 0 .9 0 .6.6 0 0 1 .6-.6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeduplicate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deduplicate.a0dab904.svg";